import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http_auth} from "@utils"
import * as auth from "../Auth"
import {REFRESH_TOKEN} from "../../../utility/Utils"
import {toast} from "react-toastify"

export const getGiveCauses = createAsyncThunk('give/getGiveCauses', async (type, {dispatch}) => {
    try {
        const response = await http_auth.get(`/registration/v1/reference/give-causes/${type}`)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const getDeclineCauses = createAsyncThunk('give/getDeclineCauses', async (type, {dispatch}) => {
    try {
        const response = await http_auth.get(`/registration/v1/reference/decline-causes/${type}`)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const uploadFileCauses = createAsyncThunk('give/uploadFileCauses', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/file/v1/attachment/upload-save`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const exportThingRegister = createAsyncThunk('give/exportThingRegister', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/file/v1/report/export-thing-register`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const exportThingRegisterCount = createAsyncThunk('give/exportThingRegisterCount', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/file/v1/report/export-thing-register-count`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const exportNotifyCount = createAsyncThunk('give/exportNotifyCount', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/file/v1/report/export-notify-register`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const exportRefCount = createAsyncThunk('give/exportRefCount', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/file/v1/report/export-lost-refs-register`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const exportDeclineRequest = createAsyncThunk('give/exportDeclineRequest', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post(`/file/v1/report/export-found-decline-register`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})
export const giveOwner = createAsyncThunk('give/giveOwner', async (data, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.post(`/registration/v1/found/give-owner`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const getDeclineRequest = createAsyncThunk('give/getDeclineRequest', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post(`/file/v1/found/decline-request`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const givenEntityItem = createAsyncThunk('give/givenEntityItem', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post(`/registration/v1/found/send-doc-to-given-entity`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const givenArchiveItem = createAsyncThunk('give/givenArchiveItem', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post(`/registration/v1/found/send-doc-to-archive`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const afterExpertizeDoc = createAsyncThunk('give/afterExpertizeDoc', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post(`/registration/v1/found/destroy-doc-after-expertize`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const putToAuction = createAsyncThunk('give/putToAuction', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post(`/registration/v1/found/put-object-to-auction`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})


export const soldToAuction = createAsyncThunk('give/soldToAuction', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post(`/registration/v1/found/object-sold-in-auction`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const giveToFounder = createAsyncThunk('give/giveToFounder', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post(`/registration/v1/found/give-founder`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const giveFounderOwning = createAsyncThunk('give/giveFounderOwning', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post(`/registration/v1/found/inform-founder-by-owning`, data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const getPersonData = createAsyncThunk('give/getPersonData', async (query, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.get(`/integration/v1/person/get-by-passport-pnfl`, {
            params: query
        })
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const getLegalData = createAsyncThunk('give/getLegalData', async (query, {rejectWithValue, dispatch}) => {
    try {
        const response = await http_auth.get(`/integration/v1/entity/get-by-tin`, {
            params: query
        })
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const giveThingSlice = createSlice({
    name: 'giveThing',
    initialState: {
        giveCause: [],
        declineCause: [],
        declineSelectItems: [],
        declineSelectItemsList: [],
        giveOwner: null,
        uploadFile: [],
        personData: null,
        legalData: null,
        giveThingStatus: '',
        commentGiveItem: '',
        sms_code: '',
        timeForDecline: '',
        requestNumber: '',

        currentPage: 0,
        totalItem: 0,
        totalPages: 0,
        isLoading: false
    },
    reducers: {
        handleGiveStatus: (state, action) => {
            state.giveThingStatus = action.payload
        },
        handleGiveComment: (state, action) => {
            state.commentGiveItem = action.payload
        },
        enterCode: (state, action) => {
            state.sms_code = action.payload
        },
        handleTime: (state, action) => {
            state.timeForDecline = action.payload
        },
        handleReqNum: (state, action) => {
            state.requestNumber = action.payload
        },
        handleSelectDeclineCauses: (state, action) => {
            state.declineSelectItems.push(action.payload)
        },
        handleSelectDeclineCausesList: (state, action) => {
            state.declineSelectItemsList = action.payload
        },
        handleSelectDeclineList: (state, action) => {
            state.declineSelectItems = action.payload
        },
        handlePushFilesList: (state, action) => {
            state.uploadFile = action.payload
        }
    },
    extraReducers: {
        [getGiveCauses.fulfilled]: (state, actions) => {
            state.giveCause = actions.payload?.data
        },
        [getDeclineCauses.fulfilled]: (state, actions) => {
            state.declineCause = actions.payload?.data
        },
        [uploadFileCauses.fulfilled]: (state, actions) => {
            state.uploadFile.push(actions.payload?.data?.id)
            state.isLoading = false
        },
        [uploadFileCauses.pending]: (state) => {
            state.isLoading = true
        },
        [uploadFileCauses.rejected]: (state) => {
            state.isLoading = false
        },
        [giveOwner.fulfilled]: (state, actions) => {
            state.giveOwner = actions.payload?.data
            state.isLoading = false
        },
        [giveOwner.pending]: (state) => {
            state.isLoading = true
        },
        [giveOwner.rejected]: (state, action) => {
            toast.error(action?.payload)
            state.isLoading = false
        },


        [getPersonData.fulfilled]: (state, actions) => {
            state.personData = actions.payload?.data
            state.isLoading = false
        },
        [getPersonData.pending]: (state) => {
            state.isLoading = true
        },
        [getPersonData.rejected]: (state) => {
            state.isLoading = false
        },


        [getLegalData.fulfilled]: (state, actions) => {
            state.legalData = actions.payload?.data
            state.isLoading = false
        },
        [getLegalData.pending]: (state) => {
            state.isLoading = true
        },
        [getLegalData.rejected]: (state) => {
            state.isLoading = false
        },


        [giveFounderOwning.fulfilled]: (state) => {
            state.isLoading = false
        },
        [giveFounderOwning.pending]: (state) => {
            state.isLoading = true
        },
        [giveFounderOwning.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },
        [giveOwner.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },
        [getDeclineRequest.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },
        [givenEntityItem.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },
        [givenArchiveItem.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },
        [afterExpertizeDoc.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },
        [putToAuction.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },
        [soldToAuction.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        },
        [giveToFounder.rejected]: (state, action) => {
            toast.error(action.payload)
            state.isLoading = false
        }
    }
})

export const {
    handleGiveStatus,
    handleGiveComment,
    enterCode,
    handleSelectDeclineCauses,
    handleSelectDeclineCausesList,
    handleReqNum,
    handleTime,
    handleSelectDeclineList,
    handlePushFilesList
} = giveThingSlice.actions
export default giveThingSlice.reducer
